/**
 * Unified design system for The Operator Method
 * Used across all pages (front of wall + behind wall) for consistency
 */

export const DESIGN_SYSTEM = {
  // ─── Backgrounds ─────────────────────────────────────
  backgrounds: {
    assessment: '#060a1d',     // MicroAssessmentPage, assessment flow
    chat: '#0a0e1a',           // InstructorChat (both demo & training)
    course: '#06091a',         // V2CoursePage, course sandbox
    neural: {
      // NeuralNexusBackground gradient overlay (shared across all behind-wall pages)
      primary:
        'radial-gradient(95% 75% at calc(50% + (var(--nnb-x, 0.5) - 0.5) * 20%) calc(18% + (var(--nnb-y, 0.5) - 0.5) * 16%), rgba(57, 213, 255, 0.14), transparent 50%), radial-gradient(75% 70% at calc(75% - (var(--nnb-x, 0.5) - 0.5) * 18%) 86%, rgba(208, 171, 98, 0.12), transparent 56%), linear-gradient(165deg, rgba(5, 8, 24, 0.92) 0%, rgba(10, 19, 48, 0.56) 45%, rgba(8, 12, 30, 0.88) 100%)',
      overlay:
        'repeating-linear-gradient(-28deg, rgba(152, 236, 255, 0.06) 0, rgba(152, 236, 255, 0.06) 1px, transparent 1px, transparent 84px)',
    },
  },

  // ─── Card Styles ──────────────────────────────────────
  cards: {
    assessment: {
      // Assessment theme card (used in micro-assessment, assessment flow)
      border: '1px solid rgba(153,179,214,0.24)',
      background: 'linear-gradient(165deg, rgba(8,18,44,0.9), rgba(7,12,29,0.72))',
      boxShadow: '0 34px 78px rgba(1,6,20,0.58), 0 12px 24px rgba(1,6,20,0.42), inset 0 1px 0 rgba(233,243,255,0.08)',
      borderRadius: '14px',
    },
    chat: {
      // Standard chat bubble/card
      border: '1px solid rgba(0,180,255,0.2)',
      background: 'rgba(0,100,180,0.13)',
      borderRadius: '4px 18px 18px 18px',
    },
    draggable: {
      // Draggable card container (split-screen, responsive layouts)
      border: '1px solid #2a3245',
      borderRadius: '14px',
      background: 'rgba(17, 24, 39, 0.88)',
      backdropFilter: 'blur(10px)',
      boxShadow: '0 0 40px rgba(57, 213, 255, 0.07), 0 8px 32px rgba(0, 0, 0, 0.55)',
    },
  },

  // ─── Layout ───────────────────────────────────────────
  layout: {
    chatPanelMaxWidth: '50%',  // Chat always max 50% width
    sandboxPanelWidth: '50%',  // Sandbox takes remaining 50%
    globalNavHeight: 42,       // Fixed height of top nav header
  },

  // ─── Accents & Highlights ──────────────────────────────
  accent: {
    cyan: '#00d4ff',
    cyanLight: 'rgba(0,180,255,0.5)',
    cyanDim: 'rgba(0,180,255,0.15)',
    purple: '#a78bfa',
    green: '#34d399',
  },

  // ─── Typography ────────────────────────────────────────
  fonts: {
    family: "'Inter', -apple-system, sans-serif",
    label: { fontSize: '10px', fontWeight: 700, letterSpacing: '0.18em', textTransform: 'uppercase' },
    heading: { fontSize: '22px', fontWeight: 700 },
    body: { fontSize: '15px', lineHeight: 1.75 },
    small: { fontSize: '12px' },
  },
};
